module.exports = __webpack_public_path__ + "static/notebook_701-3f45ca52fc3e2044d8225f49b23270dc.png";